export const setThemeMode = (mode) => ({
  type: 'SET_THEME_MODE',
  payload: { mode },
});
